var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4912 1.68323C12.2093 1.43892 11.7907 1.43892 11.5088 1.68323L0.258814 11.4332C-0.0542028 11.7045 -0.0880361 12.1782 0.183245 12.4912C0.454526 12.8042 0.928193 12.838 1.24121 12.5668L12 3.24247L22.7588 12.5668C23.0718 12.838 23.5455 12.8042 23.8168 12.4912C24.0881 12.1782 24.0542 11.7045 23.7412 11.4332L12.4912 1.68323ZM11.5148 5.92813C11.7947 5.69064 12.2053 5.69064 12.4852 5.92813L20.7352 12.9281C20.9032 13.0706 21 13.2798 21 13.5V19.75C21 20.4794 20.7103 21.1788 20.1945 21.6946C19.6788 22.2103 18.9793 22.5 18.25 22.5H5.75C5.02065 22.5 4.32118 22.2103 3.80546 21.6946C3.28973 21.1788 3 20.4794 3 19.75V13.5C3 13.2798 3.09682 13.0706 3.26477 12.9281L11.5148 5.92813ZM4.5 13.8472V19.75C4.5 20.0815 4.6317 20.3995 4.86612 20.6339C5.10054 20.8683 5.41848 21 5.75 21H9V14.25C9 13.8358 9.33579 13.5 9.75 13.5H14.25C14.6642 13.5 15 13.8358 15 14.25V21H18.25C18.5815 21 18.8995 20.8683 19.1339 20.6339C19.3683 20.3995 19.5 20.0815 19.5 19.75V13.8472L12 7.48361L4.5 13.8472ZM13.5 15V21H10.5V15H13.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.cc8d4459a9a6647468e42f24ac8bdcf3.svg";